import React from 'react';
const tags = ['U10/U12', 'U13/U15', 'U17/U19', 'Físico', 'Táctica', 'Gestión'];
export function SolutionSection() {
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-215">
      <div className="max-w-3xl mx-auto text-center" data-id="element-216">
        <div className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A0A0F] font-bold text-xs px-4 py-1.5 rounded-full mb-6 tracking-wide" data-id="element-217">
          🏆 Sistema N°1 para Entrenadores de Vóley
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-white mb-2" data-id="element-218">
          EDULABS <span className="text-[#FF6B00]" data-id="element-219">MegaPack</span>
        </h2>

        <p className="text-white text-base sm:text-lg max-w-xl mx-auto mb-3" data-id="element-220">
          <strong data-id="element-221">6 Tomos + 6 Bonos</strong> —{' '}
          <span className="text-[#FF6B00] font-bold" data-id="element-222">
            Todo resuelto, todos los niveles.
          </span>
        </p>

        <div className="flex items-center justify-center gap-2 sm:gap-4 text-[#B0B0C0] text-sm font-bold mb-6" data-id="element-223">
          <span data-id="element-224">📄 +300 págs</span>
          <span className="text-[#FF6B0066]" data-id="element-225">·</span>
          <span data-id="element-226">🏐 150 sesiones</span>
          <span className="text-[#FF6B0066]" data-id="element-227">·</span>
          <span data-id="element-228">⚡ 101 drills</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-229">
          {tags.map(tag => <span key={tag} className="bg-[#FF6B0033] text-[#FF6B00] text-xs font-bold px-3 py-1.5 rounded-full" data-id="element-230">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}